export class EventConstants {
  static readonly REEL_SPIN_DONE = "REEL_SPIN_DONE";
  static readonly HIDE_FRAMES = "HIDE_FRAMES";
  static readonly SPIN_STEP_DONE = "SPIN_STEP_DONE";
}